/**
 * @fileoverview Landing page footer section.
 * @module features/landing/components/FooterSection
 */

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { PrivacyPolicyDialog } from './PrivacyPolicyDialog'
import { TermsOfUseDialog } from './TermsOfUseDialog'

/**
 * Footer section with company name and placeholder links.
 *
 * @component
 */
export function FooterSection(): ReactElement {
  const { t } = useTranslation('features-landing')

  return (
    <footer className="py-12 border-t border-border/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Company name */}
          <p className="text-sm text-muted-foreground">
            © 2025 AbyssBlock
          </p>

          {/* Navigation links */}
          <nav className="flex flex-wrap items-center justify-center gap-2">
            <Button variant="ghost" size="sm" className="text-muted-foreground hover:text-foreground">
              {t('footer.contact')}
            </Button>
            <PrivacyPolicyDialog>
              <Button variant="ghost" size="sm" className="text-muted-foreground hover:text-foreground">
                {t('footer.privacyPolicy')}
              </Button>
            </PrivacyPolicyDialog>
            <TermsOfUseDialog>
              <Button variant="ghost" size="sm" className="text-muted-foreground hover:text-foreground">
                {t('footer.termsOfUse')}
              </Button>
            </TermsOfUseDialog>
          </nav>
        </div>
      </div>
    </footer>
  )
}
